import React, { useState } from "react";

// import "./styles.css";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isEmpty } from "lodash";
import { Empty, Popconfirm, Spin } from "antd";
import { MdOutlineArchive } from "react-icons/md";
import { Collapse , Tooltip , theme , Button  } from "antd";
import { RiDraggable } from "react-icons/ri";
import clock from "../../assets/Clock.png";
import { FiEdit2 } from "react-icons/fi";
import { GoPlus } from "react-icons/go";
import DragAndDrop from "../DragAndDrop";
import { sortLessonByOrder } from "../../utils";

const { Panel } = Collapse;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  width: "100%",
  position: "relative",
});

const DragAndDropCollapse = ({
  items,
  level,
  setItems,
  loading,
  addArchiveModule,
  handleAddTarget,
  handleEditModule,
  updateLevelDnD,
  handleTargetClick,
  addArchiveLesson
}) => {
  // console.log("🚀 ~ items:", items)
  const [dragItemId, setDragItemId] = useState("");

  const queryAttr = "data-rbd-drag-handle-draggable-id";
  const [placeholderProps, setPlaceholderProps] = useState({});

  const handleDragStart = (event) => {
    const draggedDOM = getDraggedDom(String(event.draggableId));
    setDragItemId(event?.draggableId);

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const sourceIndex = event.source.index;
    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      [...draggedDOM.parentNode.children]
        .slice(0, sourceIndex)
        .reduce((total, curr) => {
          const style = curr.currentStyle || window.getComputedStyle(curr);
          const marginBottom = parseFloat(style.marginBottom);
          return total + curr.clientHeight + marginBottom;
        }, 0);

    setPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(
        window.getComputedStyle(draggedDOM.parentNode).paddingLeft
      ),
    });
  };

  const handleDragEnd = (result) => {
    setPlaceholderProps({});
    if (!result.destination) {
      return;
    }

    const listItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    // console.log("Yolooooo", {
    //   items,
    //   source: result.source.index,
    //   destination: result.destination.index,
    // });

    const sourceId = items[result.source.index].moduleId;
    const destinationId = items[result.destination.index].moduleId;

    // console.log("Yolooooo", {
    //   sourceId,
    //   destinationId,
    // });
    // console.log("🚀 ~ handleDragEnd ~ listItems:", listItems)

    setItems(listItems);

    // handleDropEnd(listItems);

    setDragItemId("");
  };

  const handleDragUpdate = (event) => {
    if (!event.destination) {
      return;
    }

    const draggedDOM = getDraggedDom(String(event.draggableId));

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const destinationIndex = event.destination.index;
    const sourceIndex = event.source.index;

    const childrenArray = [...draggedDOM.parentNode.children];
    const movedItem = childrenArray[sourceIndex];
    childrenArray.splice(sourceIndex, 1);

    const updatedArray = [
      ...childrenArray.slice(0, destinationIndex),
      movedItem,
      ...childrenArray.slice(destinationIndex + 1),
    ];

    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
        const style = curr.currentStyle || window.getComputedStyle(curr);
        const marginBottom = parseFloat(style.marginBottom);
        return total + curr.clientHeight + marginBottom;
      }, 0);

    setPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(
        window.getComputedStyle(draggedDOM.parentNode).paddingLeft
      ),
    });
  };

  const getDraggedDom = (draggableId) => {
    const domQuery = `[${queryAttr}='${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);

    return draggedDOM;
  };
  // const handleModuleDragEnd = (result, level) => {
  //   if (!result.destination) return;
  
  //   const reorderedModules = reorder(
  //     level.modules,
  //     result.source.index,
  //     result.destination.index
  //   );
  
  //   // Update modules inside that level
  //   // const updatedLevels = levels.map((l : any) => {
  //   //   if (l.levelId === level.levelId) {
  //   //     return {
  //   //       ...l,
  //   //       modules: reorderedModules,
  //   //     };
  //   //   }
  //   //   return l;
  //   // });
  
  //   // setLevels(updatedLevels); // Assuming you have a useState for levels
  // };
  return (
    <DragDropContext
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
      onDragUpdate={handleDragUpdate}
    >
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {loading ? (
              <div className="loadingBox">
                <Spin />
              </div>
            ) : items?.length > 0 ? (
              items.map((item, index) => {
                return (
                  <Draggable
                    key={String(item.moduleId)}
                    draggableId={String(item.moduleId)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                        className={`${
                          dragItemId == item.moduleId ? "activeDrag" : ""
                        }`}
                      >
                        <ModuleCollapseSection
                          module={item}
                          level={level}
                          addArchiveModule={addArchiveModule}
                          handleAddTarget={handleAddTarget}
                          handleEditModule={handleEditModule}
                          updateLevelDnD={updateLevelDnD}
                          handleTargetClick={handleTargetClick}
                          addArchiveLesson={addArchiveLesson}
                        />
                      </div>
                    )}
                  </Draggable>
                );})
            ) : (
              <Empty
                style={{ marginBottom: "30px" }}
                description="No step here"
              />
            )} 
            {provided.placeholder}
            {!isEmpty(placeholderProps) && snapshot.isDraggingOver && (
              <div
                className="placeholder"
                style={{
                  top: placeholderProps?.clientY,
                  //   left: placeholderProps.clientX,
                  right: 0,
                  height: placeholderProps.clientHeight - 30,
                  width: placeholderProps.clientWidth - 40,
                }}
              />
            )}
          </div>
        )}
      </Droppable>

      {/* {type === "funnel" && <Footer />} */}
    </DragDropContext>
  );
};

const ModuleCollapseSection = ({
  module,
  level,
  addArchiveModule,
  handleAddTarget,
  handleEditModule,
  updateLevelDnD,
  handleTargetClick,
  addArchiveLesson,
}) => {
  const { token } = theme.useToken();
  const panelStyle = {
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
  };

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={["1"]}
      expandIcon={() => false}
      // expandIcon={({ isActive }) => (
      //   <IoIosArrowDown
      //     size={20}
      //     className={`arrow-icon ${isActive ? "rotate" : ""} ${
      //       hoveredPanel ? "hovered" : ""
      //     }`}
      //   />
      // )}
      style={{ background: token.colorBgContainer }}
      accordion
      className="_innerCollapse"
    >
      <Panel
        key={module?.name}
        header={
          <p className="panel_hdr_content">
            <Tooltip placement="bottom" title={"Hold and move to drag"}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  cursor: "grab",
                }}
              >
                <RiDraggable size={20} />
              </div>
            </Tooltip>
            {module?.name}
            <div className="moduledurationclock">
              <img src={clock} alt="" className="imgclock" />
              <p>
                Module Duration: {module?.targets?.length}{" "}
                {module?.targets?.length > 1 ? "Targets" : "Target"}
              </p>
            </div>
            <div className="moduledurationclock">
              <img src={clock} alt="" className="imgclock" />
              <p>
                {module?.targets
                  .map((t) => t?.duration)
                  .reduce((sum, val) => Number(sum) + Number(val), 0)}{" "}
                {module?.targets?.length > 1 ? "Lessons" : "Lesson"}
              </p>
            </div>
          </p>
        }
        style={panelStyle}
        className="innerpanel"
        extra={
          <>
            <Tooltip placement="bottom" title={"Add Target"}>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddTarget(module?.moduleId, level?.levelId);
                }}
                className="black-button collapse_action_btn"
                icon={<GoPlus size={25} />}
              />
            </Tooltip>
            <Tooltip placement="bottom" title={"Edit Module"}>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditModule(module);
                }}
                className="black-button collapse_action_btn"
                icon={<FiEdit2 size={22} />}
              />
            </Tooltip>
            <Tooltip>
              <Popconfirm
                title="Archive Module"
                description="Are you sure add to archive ?"
                onConfirm={(e) => {
                  console.log(e);
                  e.stopPropagation();
                  addArchiveModule(module.moduleId);
                }}
                okText="Yes"
                cancelText="No"
              >
                <MdOutlineArchive
                  className="archive_unarchive_btn"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </Popconfirm>
            </Tooltip>
          </>
        }
      >
        {/* @ts-ignore */}
        <DragAndDrop
          items={sortLessonByOrder(module?.targets)}
          setItems={(targets) =>
            updateLevelDnD(level.levelId, module.moduleId, targets)
          }
          handleTargetClick={(lessonId) =>
            handleTargetClick(lessonId, level, module.moduleId)
          }
          addArchiveLesson={addArchiveLesson}
        />
      </Panel>
    </Collapse>
  );
};



export default DragAndDropCollapse;
